import React from "react";
import FPUContent from "../../components/layouts/misi-internasional/FPUContent";

const FPU: React.FC = () => {
  return (
    <div>
      <FPUContent />
    </div>
  );
};

export default FPU;
